<template>
  <div
    class="page_container addCommondity"
    v-loading="loading"
    element-loading-text="提交中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >促销优惠&市场活动</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/shopIndex' }"
          >市场活动管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/shopIndex/activityList' }"
          >活动详情</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{
          formData.id == "" ? "新增活动详情" : "活动详情设置"
        }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 主要内容 start -->
    <div class="form_container">
      <h1>{{ formData.id == "" ? "新增活动详情" : "活动详情设置" }}</h1>
      <div class="content_wrap flex-rowl">
        <div class="form_wrap">
          <div class="block">
            <p><span class="mark">*</span>指定样式内容</p>
            <div class="radio_box">
              <el-radio-group v-model="formData.conttype">
                <el-radio :label="1">大图内容段</el-radio>
                <el-radio :label="2">视频内容段</el-radio>
                <el-radio :label="3">文字内容段</el-radio>
              </el-radio-group>
            </div>
          </div>

          <div
            class="block"
            v-if="formData.conttype == 1 || formData.conttype == 2"
          >
            <p><span class="mark">*</span>图片或者视频封面</p>
            <p class="red">JPG或者PNG格式，尺寸比例为500*500像素</p>
            <div
              class="upload_box"
              @mouseenter="enter(1)"
              @mouseleave="creenIndex = ''"
            >
              <el-upload
                action
                list-type="picture-card"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :http-request="beforeAvatarUpload"
              >
                <div v-if="formData.picurl">
                  <img :src="baseUrl + formData.picurl" class="avatar" />
                  <div
                    class="el-upload-list__item-actions flex-rowc"
                    v-show="creenIndex == 1"
                  >
                    <span
                      @click.stop="
                        handlePictureCardPreview(baseUrl + formData.picurl, 1)
                      "
                      ><i class="iconfont icon-fangda"></i
                    ></span>
                    <span @click.stop="handleRemove(1)"
                      ><i class="iconfont icon-icon_shanchu-"></i
                    ></span>
                  </div>
                </div>

                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
          </div>
          <div class="block" v-if="formData.conttype == 2">
            <p><span class="mark">*</span>视频</p>
            <div class="video_box">
              <div v-if="formData.videourl != ''">
                <video :src="formData.videourl" controls></video>
              </div>
              <div v-else class="noData" @click="openFileInputVideo()">
                <i class="el-icon-plus avatar-uploader-icon"></i>
              </div>
            </div>
          </div>
          <div class="block" v-if="formData.conttype == 3">
            <p><span class="mark">*</span>详情内容：</p>
            <div class="input_box">
              <el-input
                v-model="formData.details"
                type="textarea"
                placeholder="输入详情内容"
              ></el-input>
            </div>
          </div>
            <div class="block">
            <p>排序：</p>
            <div class="select_box">
              <el-input
                v-model="formData.sortno"
                placeholder="请输入排序"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="tip_wrap"></div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="query">确认</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
    <!-- 主要内容 end -->

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>

    <input
      type="file"
      ref="fileInputVideo"
      style="display: none"
      @change="addVideoContent"
      accept="video/*"
    />
  </div>
</template>

<script>
import axios from "axios";
import {
  uploadPosterImage,
  getUploadToken,
  encryptstringview,
} from "../../api/api";
import {
  getActivityDetailDetail,
  editActivityDetail,
  addActivityDetail,
} from "../../api/shop";
export default {
  name: "activityDetail",
  data() {
    return {
      baseUrl: process.env.VUE_APP_IMG_BASE_API,
      searchText: "",

      loading: false,
      barndId: "", // 选中品牌id
      brandName: "", // 选中品牌name
      brandItem: "", // 选中品牌item
      brandList: "", // 品牌列表
      formData: {
        id: "",
        actid: "",
        conttype: "",
        picurl: "",
        videourl: "",
        details: "",
        sortno: "",
      },
      creenIndex: 1,
      dialogImageUrl: "",
      dialogVisible: false,
    };
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id, actid } = JSON.parse(res.jsondata);
        this.formData.id = id;
        this.formData.actid = actid;
        if (id != "") {
          this.getActivityDetailDetail(id);
        }
      } else {
        this.$router.back();
      }
    },

    // 获取活动详情
    getActivityDetailDetail(id) {
      getActivityDetailDetail({ id }).then((res) => {
        this.formData.conttype = parseInt(res.conttype);
        this.formData.picurl = res.picurl;
        this.formData.city = res.city;
        this.formData.videourl = res.videourl ? res.videourl : "";
        this.formData.details = res.details;
        this.formData.sortno = res.sortno;
      });
    },

    // 移出图片
    handleRemove(isType) {
      if (isType == 1) {
        this.formData.picurl = "";
      }
    },
    // 大图预览
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },
    // 移入图片区域
    enter(type) {
      this.creenIndex = type;
    },

    handleAvatarSuccess(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      if (!isJPG) {
        this.$message.error("缩略图只能是图片");
      }
    },
    beforeAvatarUpload(e) {
      let { creenIndex } = this;
      var formData = new FormData();
      formData.append("imgfile", e.file);
      this.loading = true;
      uploadPosterImage(formData).then((res) => {
        if (res.result) {
          this.loading = false;
          if (creenIndex == 1) {
            this.formData.picurl = res.code;
          }
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },

    // 3、新增视频内容
    openFileInputVideo() {
      this.$refs.fileInputVideo.click();
    },
    addVideoContent(e) {
      this.loading = true;
      getUploadToken().then((res) => {
        var formData = new FormData();
        formData.append("name", "file");
        formData.append("key", res.key);
        formData.append("policy", res.policy);
        formData.append("OSSAccessKeyId", res.OSSAccessKeyId);
        formData.append("success_action_status", "200");
        formData.append("signature", res.signature);
        formData.append("file", e.target.files[0]);
        const config = {
          onUploadProgress: this.setUploadProgress, // 将方法绑定到上传进度事件上
        };
        return new Promise((resolve, reject) => {
          axios
            .post("https://upload.vwingist.com/", formData, config)
            .then((response) => {
              // 请求成功的处理
              if (response.status === 200) {
                resolve(response.data);
                //返回数据根据结果进行相应的处理
                this.formData.videourl = res.host + "/" + res.key;
                // if (editId != "") {
                //   contents.forEach((v) => {
                //     if (v.id == editId) {
                //       v.videourl = res.host + "/" + res.key;
                //     }
                //   });
                // } else {
                //   if (addIndex === "") {
                //     let sortno = contents.length + 1; // 根据数组长度设置排序值
                //     contents.push({
                //       cmid,
                //       sortno,
                //       conttype: 2,
                //       picurl: "",
                //       videourl: res.host + "/" + res.key,
                //       details: "",
                //     });
                //     // this.updateSort();
                //   } else {
                //     this.isShowContentSelect = false;
                //     this.contents.splice(addIndex + 1, 0, {
                //       cmid,
                //       sortno: addIndex,
                //       conttype: 2,
                //       picurl: "",
                //       videourl: res.host + "/" + res.key,
                //       details: "",
                //     });
                //     this.addIndex = "";
                //     this.updateSort(true);
                //   }
                // }
              } else {
                reject("请求失败");
              }
            })
            .catch((error) => {
              reject(error);
            });
        });
      });
    },
    // 设置上传进度
    setUploadProgress(event) {
      // 进度处理逻辑
      const progress = Math.round((event.loaded / event.total) * 100);
      this.loadingText = `上传:${progress}%`;
      if (progress == 100) {
        this.loading = false;
      }
    },

    // 返回上一页
    handleReturn() {
      this.$router.push({ name: "shopIndex" });
    },

    // 提交数据
    query() {
      let { formData } = this;
      if (formData.conttype == "") {
        this.$message.warning("请选择指定样式内容");
        return;
      }
      if (formData.conttype == 1 && formData.picurl == "") {
        this.$message.warning("请上传图片或者视频封面");
        return;
      }
      if (formData.conttype == 2 && formData.videourl == "") {
        this.$message.warning("请上传视频");
        return;
      }
      if (formData.conttype == 3 && formData.details == "") {
        this.$message.warning("请输入文字内容段");
        return;
      }
      this.loading = true;

      if (formData.id == "") {
        this.loading = true;
        addActivityDetail(formData).then((res) => {
          if (res.result) {
            setTimeout(() => {
              this.loading = false;
              this.$router.back();
            }, 500);
          } else {
            this.loading = false;
            this.$message.error(res.message || "服务器报错，请稍后～");
          }
        });
      } else {
        this.loading = true;
        editActivityDetail(formData).then((res) => {
          if (res.result) {
            setTimeout(() => {
              this.loading = false;
              this.$message.success(res.message);
            }, 500);
          } else {
            this.loading = false;
            this.$message.error(res.message || "服务器报错，请稍后～");
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.addCommondity {
  .form_container {
    h1 {
      font-size: 20px;
      color: #404d6c;
      margin-bottom: 28px;
    }
    .content_wrap {
      align-items: flex-start;
      .form_wrap {
        flex: 1;
        margin-right: 100px;
        .block {
          margin-bottom: 45px;
          .input_box {
            margin-bottom: 20px;
          }
        }
      }
      .tip_wrap {
        flex: 1;
      }
      p {
        font-size: 18px;
        color: #6e6e6e;
        margin-bottom: 8px;
        &.red {
          font-size: 16px;
          color: #ff0012;
          line-height: 26px;
          // margin-bottom: 0;
        }
        .mark {
          color: #ff0012;
          font-size: 14px;
          margin-right: 4px;
        }
      }
    }
  }
  .custom_wrap {
    .diaog_head {
      height: 80px;
      h1 {
        font-size: 18px;
        color: #6e6e6e;
      }
      p {
        font-size: 14px;
        color: #ff0012;
        margin: 10px 0 8px;
      }
    }
    .diaog_body {
      // height: calc(68vh - 160px);
      .radio_wrap {
        .radio_group {
          flex-wrap: wrap;
          .radio_item {
            margin-right: 80px;
            font-size: 14px;
            color: #6e6e6e;
            margin-bottom: 20px;
            cursor: pointer;
            .iconfont {
              font-size: 22px;
              margin-right: 5px;
              color: #a5a5a5;
              &.icon-danxuanyixuan1 {
                color: #ea4e4e;
              }
            }
          }
        }
      }
    }
    .dialog_footer {
      .link {
        a {
          font-size: 16px;
          color: #fe3c46;
        }
      }
    }
  }
  .video_box {
    width: 150px;
    video {
      width: 100%;
    }
    .avatar-uploader-icon {
      color: #8c939d;
      font-size: 30px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    .noData {
      cursor: pointer;
      height: 150px;
      border: 1px dashed #c0ccda;
      position: relative;
      border-radius: 10px;
    }
  }
}
</style>